<div>
        <input 
                type="button"
                value="Add"
                class="btn btn-success float-end"
                (click)="addLabelPreparationSetup()"
                [disabled]="formId == 0" 
        />
        <input 
                #labelPreparationSetupModalButton
                type="button"
                [attr.data-bs-toggle]="'modal'"
                [attr.data-bs-target]="'#labelpreparation-form'"
                class="hidden"
        />
        <div 
                class="modal" 
                id="labelpreparation-form" 
                tabindex="-1"
                data-bs-backdrop="static"
                data-bs-keyboard="false"
                role="dialog"
        >
                <app-labelpreparation-form 
                        #labelPreparationSetupForm
                        *ngIf="showLabelPreparationSetupModal"
                        [isViewMode]="isViewMode"
                        [isEditMode]="isEditMode"
                        [labelPreparationSetup]="labelPreparationSetup"
                        [labelPreparationFormQuestions]="labelPreparationFormQuestions"
                        [labelPreparationHeaderCoreQuestions]="labelPreparationHeaderCoreQuestions"
                        (onSaveLabelPreparationSetupForm)="onSaveLabelPreparationSetupForm()"
                        (onCloseLabelPreparationSetupModal)="onCloseLabelPreparationSetupModal()"
                ></app-labelpreparation-form>
        </div>
</div>
<div class="clearfix"></div>
<div>
    <data-table 
        [dataset]="labelPreparationRegister" 
        [showExport]="false" 
        [paginator]="false" 
        [class]="'override-height'"
        [loading]="loading">
        <column [value]="'name'"
                [header]="'Name'"
                [filterable]="false"
                [sortable]="false"
                [styleClass]="'text-start'"
                width="300px"
                [frozen]="false"></column>
        <column [value]="'lastUpdated'"
                [header]="'Last Updated'" [filterable]="false"
                [sortable]="false"
                [styleClass]="'text-start'"
                width="200px"></column>
        <column [value]="'lastUpdatedBy'"
                [header]="'Last Updated By'" [filterable]="false"
                [sortable]="false"
                [styleClass]="'text-start'"
                width="250px"></column>
        <column [value]="'status'"
                [header]="'Status'" [filterable]="false"
                [sortable]="false"
                [styleClass]="'text-start'"
                width="100px"></column>
        <column [options]="'options'"
                [filterable]="false"
                [sortable]="false"
                [styleClass]="'text-center'"></column>
    </data-table>
</div>
